import { EventTracker } from '@/utils';
import { FORMULA_PATH, MY_FOODS_PATH, MY_REPORTS_PATH } from '@/constants/paths';
import { FileBarChart, Apple, TestTube2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import type { LucideIcon } from 'lucide-react';
import { IKitType, KitType } from '@viome/viome-base/src/usecase/Bootup/BootupModel';

interface QuickActionConfig {
  id: string;
  label: string;
  icon: LucideIcon;
  iconColor: string;
  tileBackground: string;
  iconBackground: string;
  path: string;
  eventName: string;
}

const QUICK_ACTIONS: QuickActionConfig[] = [
  {
    id: 'results-pdf',
    label: 'Results PDF',
    icon: FileBarChart,
    iconColor: '#7C3AED',
    tileBackground: '#F3EEFF',
    iconBackground: '#EDE9FE',
    path: MY_REPORTS_PATH,
    eventName: 'home_quickAction_resultsPdf',
  },
  {
    id: 'my-foods',
    label: 'My Foods',
    icon: Apple,
    iconColor: '#16A34A',
    tileBackground: '#EDFAF3',
    iconBackground: '#DCFCE7',
    path: MY_FOODS_PATH,
    eventName: 'home_quickAction_myFoods',
  },
  {
    id: 'my-ingredients',
    label: 'My Ingredients',
    icon: TestTube2,
    iconColor: '#EA580C',
    tileBackground: '#FFF4ED',
    iconBackground: '#FFEDD5',
    path: FORMULA_PATH,
    eventName: 'home_quickAction_myIngredients',
  },
];

interface QuickActionsProps {
  kitType?: IKitType;
}

export const QuickActions = ({ kitType }: QuickActionsProps) => {
  const navigate = useNavigate();

  const visibleActions = QUICK_ACTIONS.filter(
    (action) => !(action.id === 'results-pdf' && (kitType === KitType.PHPRO || kitType === KitType.GHPRO)),
  );

  return (
    <div
      className={`grid ${visibleActions.length === 2 ? 'grid-cols-2' : 'grid-cols-3'} gap-3 pt-6`}
      data-testid="home-quickActions"
    >
      {visibleActions.map((action) => {
        const Icon = action.icon;
        return (
          <button
            key={action.id}
            className="flex flex-col items-center justify-center gap-2 rounded-xl py-5 transition-transform hover:scale-105 active:scale-95"
            style={{ backgroundColor: action.tileBackground }}
            onClick={() => {
              EventTracker.trackEvent('home', action.eventName);
              navigate(action.path);
            }}
            data-testid={`home-quickAction-${action.id}`}
          >
            <div
              className="flex items-center justify-center rounded-lg w-10 h-10"
              style={{ backgroundColor: action.iconBackground }}
            >
              <Icon size={22} color={action.iconColor} />
            </div>
            <span className="typography-caption text-primary whitespace-nowrap">
              {action.label}
            </span>
          </button>
        );
      })}
    </div>
  );
};
